import ContactSalesButton from '../_core/contactSales/ContactSalesButton';
export default ContactSalesButton;